import React, { createContext, useContext } from 'react';
import { Link, type LinkProps } from 'react-router-dom';

const ListReturnPathContext = createContext<string | null>(null);

/** Provides the current list return path (`pathname + search`) for record Links / openers. */
export const ListReturnPathProvider: React.FC<{
  value: string;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <ListReturnPathContext.Provider value={value}>{children}</ListReturnPathContext.Provider>
);

export function useListReturnPath(): string | null {
  return useContext(ListReturnPathContext);
}

type RecordLinkProps = Omit<LinkProps, 'state'> & {
  /** Override return path; defaults to ListReturnPathProvider value. */
  from?: string | null;
};

/**
 * Link to a detail/edit route that preserves `state.from` for Back navigation.
 * Uses the nearest {@link ListReturnPathProvider} when `from` is omitted.
 */
export const RecordLink: React.FC<RecordLinkProps> = ({ from, to, ...rest }) => {
  const ctxFrom = useListReturnPath();
  const returnPath = from !== undefined ? from : ctxFrom;
  return <Link to={to} state={returnPath ? { from: returnPath } : undefined} {...rest} />;
};
